/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

function subtractHours(date: any) {
  date.setHours(date.getHours() - 720);
  return date;
}

const dateNow = new Date();
const dateTime = subtractHours(dateNow);

export const getAllExpressions = () => {
  return progressApi.get(`/ExpMeta/GetAllExpressions${extractedPath}`);
};

export const getExpressionById = (id: any) => {
  return progressApi.get(`/ExpMeta/GetExpression${extractedPath}?id=${id}`);
};

export const getExpressionData = (
  ids: any,
  dateTime?: string
) => {
  let url = `Dashboard/GetExpData${extractedPath}`;
  dateTime ? (url += `?dateTime=${dateTime}`) : null;
  return progressApi.post(url, ids);
};

export const createExpression = (expression: any) => {
  return progressApi.post(`/ExpMeta/CreateExpression${extractedPath}`, expression);
};

export const getExpressionByUnit = (id: any) => {
  return progressApi.get(`/ExpMeta/GetExpressionByUnit${extractedPath}?id=${id}`);
};

export const getExpressionByEquipment = (id: any) => {
  return progressApi.get(`/ExpMeta/GetExpressionByEquipment${extractedPath}?id=${id}`);
};

export const updateExpression = (expression: any) => {
  return progressApi.post(`/ExpMeta/UpdateExpression${extractedPath}`, expression);
};

export const deleteExpression = (id: any) => {
  return progressApi.get(`/ExpMeta/DeleteExpression${extractedPath}?id=${id}`);
};

export const validateExpression = (expression: any) => {
  return progressApi.post(`/ExpMeta/ValidateExpression${extractedPath}`, expression);
};

export const getExpressionByTrain = (id: any) => {
  return progressApi.get(`/ExpMeta/GetExpressionByTrain${extractedPath}?id=${id}`);
};